// ARTWORK
import basePTLanguage from '../i18n/translation/pt.json';
import baseENLanguage from '../i18n/translation/en.json';
import baseESLanguage from '../i18n/translation/es.json';

// SISTEMA AVALIAÇÃO
import ratingSystemPT from '../features/products/rating-system/translation/pt.json';
import ratingSystemEN from '../features/products/rating-system/translation/en.json';
import ratingSystemES from '../features/products/rating-system/translation/es.json';

// PAINEL DE PRECO
import pricePanelEN from '../features/products/price-panel/translation/en.json'
import pricePanelES from '../features/products/price-panel/translation/es.json'
import pricePanelPT from '../features/products/price-panel/translation/pt.json'


import userPermissions from './userPermissions';

export const ptLanguage = basePTLanguage;
export const enLanguage = baseENLanguage;
export const esLanguage = baseESLanguage;

if (userPermissions.ratingSystem) {
  ptLanguage.translation.ratingSystem = ratingSystemPT;
  enLanguage.translation.ratingSystem = ratingSystemEN;
  esLanguage.translation.ratingSystem = ratingSystemES;
}


if (userPermissions.pricePanel) {
  ptLanguage.translation.pricePanel = pricePanelPT;
  enLanguage.translation.pricePanel = pricePanelEN;
  esLanguage.translation.pricePanel = pricePanelES;

}



